var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.500163C23.675 0.500163 21.6964 1.81345 20.0357 3.14287C17.8929 4.85212 16.0232 6.89462 14.5964 9.23633C13.5268 10.9922 12.5 13.1207 12.5 14.8335M12.5 14.8335C12.5 13.1207 11.4732 10.9904 10.4036 9.23633C8.975 6.89462 7.10536 4.85212 4.96607 3.14287C3.30357 1.81345 1.32143 0.500163 0 0.500163",
    fill: "#F0E1CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.500163C23.675 0.500163 21.6964 1.81345 20.0357 3.14287C17.8929 4.85212 16.0232 6.89462 14.5964 9.23633C13.5268 10.9922 12.5 13.1207 12.5 14.8335C12.5 13.1207 11.4732 10.9904 10.4036 9.23633C8.975 6.89462 7.10536 4.85212 4.96607 3.14287C3.30357 1.81345 1.32143 0.500163 0 0.500163",
    stroke: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.da2677ccb66c81694875681b8da8b1cb.svg";
export { ForwardRef as ReactComponent };